import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const KEY = "vr_cookie_notice_ack";

export const CookieNotice = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem(KEY)) {
            const t = setTimeout(() => setVisible(true), 1600);
            return () => clearTimeout(t);
        }
    }, []);

    const accept = () => {
        localStorage.setItem(KEY, "1");
        setVisible(false);
    };

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 24 }}
                    transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                    data-testid="cookie-notice"
                    className="fixed bottom-20 left-4 right-4 z-50 md:bottom-6 md:left-6 md:right-auto md:max-w-sm"
                >
                    <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-2xl">
                        <p className="text-sm font-semibold text-slate-900">Cookies on this website</p>
                        <p className="mt-1.5 text-xs leading-relaxed text-slate-500">
                            This website uses only essential cookies required for it to function. No marketing or
                            tracking cookies are set. See our{" "}
                            <Link to="/cookie-policy" className="font-semibold text-emerald-700 underline underline-offset-2" data-testid="cookie-notice-policy-link">
                                Cookie Policy
                            </Link>
                            .
                        </p>
                        <button
                            onClick={accept}
                            data-testid="cookie-notice-accept-button"
                            className="mt-3.5 w-full rounded-xl bg-slate-900 px-4 py-2.5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-emerald-700"
                        >
                            Got it
                        </button>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
